import {
  lazy,
  Suspense,
  useMemo,
  useState,
  ReactElement,
  useEffect
} from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  matchPath
} from "react-router-dom";
import Webfont from "webfontloader";
import "./App.css";
import "./font.css";
import { connect } from "react-redux";
import { useAsync } from "./utilities/asyncFunc";
import { getSystemSettings } from "./state_management/epics";
import { category, settings } from "./state_management/actionTypes";
import { changeLocale, setSystemSettings } from "./state_management/actions";
import { cartItem, extrasCartItem } from "./state_management/reducers/cart";
import { stateType } from "./store";
import useVersion from "./utilities/useVersion";
import { parseIdQuan } from "./state_management/epics/order";
import { getMode } from "./settings";
import { locale } from "./translate";
import { getServiceLink } from "./utilities/misc";
import { pollKey } from ".";
import { Helmet } from "react-helmet";
import initSentry from "./utilities/sentry";
import AppProvider from "./AppProvider";
import { CleaningProducts } from "./pages/Services/Service";
import Chatbase from "./utilities/Chatbase";
import BenefitsHeader from "./elements/header/BenefitsHeader";
import BreadCrumb from "./elements/header/BreadCrumb";
import DynamicBars from "./elements/header/InjectedHeader";

const CheckOut = lazy(() => import("./pages/CheckOut/CheckOut"));
const Reschedule = lazy(() => import("./elements/Reschedule/Reschedule"));
const LeaveReview = lazy(() => import("./elements/LeaveReview/LeaveReview"));
const Service = lazy(() => import("./pages/Services/Service"));
const Footer = lazy(() => import("./elements/footer/Footer"));
const Header = lazy(() => import("./elements/header/Header"));
const Cart = lazy(() => import("./pages/Cart/Cart"));

initSentry();

export const noSlash = (url: string) => {
  const regex = /^([\w-]+)\/?$/;

  const pathMatch = url.match(regex);
  const URL = pathMatch ? pathMatch[1] : null;
  return URL;
};
export const formatCategoryName = (
  category: category,
  compare = true
): string => {
  const categoryName = category.name;
  const url = category.url;
  return url
    ? compare
      ? noSlash(url) || url
      : url
    : categoryName.toLowerCase().replace(/\s/g, `-`);
};

const App = ({
  setSystemSettings,
  cart,
  extras,
  locale,
  changeLocale
}: {
  setSystemSettings: (settings: settings) => void;
  cart: cartItem[];
  extras: extrasCartItem[];
  locale: locale;
  changeLocale: (locale: locale) => void;
}) => {
  useVersion();
  const { pathname } = useLocation();
  const exludePoll =
    pathname.startsWith("/service/reschedule") || pathname.startsWith("/cart");
  const [showFeedbackPopUp, setShowFeedbackPopUp] = useState(false);
  const [feedbackGiven, giveFeedback] = useState(false);
  // const [cartTotal, setCartTotal] = useState(0);
  // const [categories, setCategories] = useState<category[]>([]);

  /* Total after discount */

  useEffect(() => {
    Webfont.load({
      custom: {
        families: [
          "AvenirNextCyr-Medium:n4,n5,n6,n7,n8,n9",
          "AvenirNextCyr-Regular:n4,n5,n6,n7,n8,n9",
          "AvenirNextCyr-Demi:n4,n5,n6,n7,n8,n9",
          "AvenirNextCyr-Bold:n4,n5,n6,n7,n8,n9"
        ]
      }
    });
  }, []);

  const compareMills = () => {
    const minTime = 4 * 60 * 60 * 1000; // time in milliseconds (4 hrs)

    const nowMilli = Date.now();
    const timeMilli = Number(localStorage.getItem(pollKey)) || 0;

    const diff = nowMilli - timeMilli;

    return diff >= minTime;
  };

  const handleExitIntent = (a: React.MouseEvent) => {
    const { clientX, clientY } = a;

    // Check if the cursor is within the document's boundaries
    const isWithinDocument =
      clientX >= 0 &&
      clientX <= window.innerWidth &&
      clientY >= 0 &&
      clientY <= window.innerHeight;

    const lastClosed = Number(localStorage.getItem(pollKey)) || 0;

    const eligibleTime = !lastClosed || compareMills();
    if (!isWithinDocument && !feedbackGiven && !exludePoll && eligibleTime) {
      // setShowFeedbackPopUp(true);
    }
  };

  const closePoll = () => {
    localStorage.setItem(pollKey, new Date().getTime().toString());
    setShowFeedbackPopUp(false);
  };

  useEffect(() => {
    if (exludePoll) {
      setShowFeedbackPopUp(false);
    }
  }, [exludePoll]);

  const settingRes = useAsync(
    {
      asyncFunc: getSystemSettings,
      funcParams: {
        services: cart.map((item) =>
          parseIdQuan({
            extra: false,
            item
          })
        ),
        extra_services: extras.map((item) =>
          parseIdQuan({
            item,
            extra: true
          })
        )
      },
      immediate: true
    },
    [JSON.stringify(cart), JSON.stringify(extras)]
  );

  useEffect(() => {
    const settings = settingRes.data;
    if (settings) {
      setSystemSettings({ ...settings });
    }
  }, [settingRes.data]);

  const mode = getMode();

  const service_link = getServiceLink(locale);

  const isEven = () => {
    const randomNumber = Math.floor(Math.random() * 10); // Generate a random number between 0 and 9
    return randomNumber % 2 === 0;
  };

  const headerPaths = useMemo(
    () => [
      `/${service_link}`,
      `/${service_link}/cleaning-products`,
      `/${service_link}/:serviceName`,
      "/cart"
    ],
    [service_link]
  );

  return (
    <AppProvider locale={locale} changeLocale={changeLocale}>
      <>
        <Helmet>
          {getMode() === "production" && locale === "lt" ? (
            <meta
              name="facebook-domain-verification"
              content="poi5e0ll26qd6dl9ln7n2i7dq0ewz7"
            />
          ) : (
            ""
          )}
        </Helmet>
        <div onMouseLeave={handleExitIntent} className="clean_bee">
          {/* <ExitPopUp
                close={closePoll}
                extraFunc={(data: boolean) => {
                  giveFeedback(data);
                }}
                show={false}
                bookingFeedBack={even}
              /> */}
          {mode === "production" ? (
            <></>
          ) : (
            <button
              className="med_text"
              style={{
                top: 16,
                left: 16,
                width: "fit-content",
                zIndex: 999
              }}
              onClick={() => {
                const getNewLocale = (): locale => {
                  if (locale === "eng") {
                    return "lt";
                  } else {
                    return "eng";
                  }
                };

                changeLocale(getNewLocale());
              }}
            >
              Change Locale
            </button>
          )}
          <Suspense fallback={<></>}>
            <Routes>
              {renderMultiRoutes({
                paths: headerPaths,
                element: <DynamicBars />
              })}
            </Routes>
            <Routes>
              {renderMultiRoutes({
                paths: headerPaths,
                element: <Header />
              })}
            </Routes>
            <RenderExcludedRoutes
              excludePaths={headerPaths}
              element={<BenefitsHeader />}
            />
            <Routes>
              {renderMultiRoutes({
                paths: headerPaths,
                element: <BreadCrumb />
              })}
            </Routes>
            <div className="clean_bee_content page">
              <Routes>
                <Route
                  path={"/"}
                  element={
                    <Navigate
                      state={{ fromHome: true }}
                      to={`/${service_link}`}
                    />
                  }
                />
                <Route path={`/${service_link}`} element={<Service />} />
                <Route
                  path={`/${service_link}/cleaning-products`}
                  element={<CleaningProducts />}
                />
                <Route
                  path={`/${service_link}/:serviceName`}
                  element={<Service />}
                />
                <Route
                  path={"/service/reschedule/:orderId/:token"}
                  element={<Reschedule settingRes={settingRes} />}
                />
                <Route
                  path={"/service/rating/:orderId/:token"}
                  element={<LeaveReview />}
                />
                <Route
                  path={"/cart"}
                  element={
                    <Cart
                      settingRes={settingRes}
                      loading={settingRes.loading}
                    />
                  }
                />
                <Route
                  path={"/checkout"}
                  element={<CheckOut settingRes={settingRes} />}
                />
                <Route path="*" element={<Navigate to={"/"} replace />} />
              </Routes>
            </div>

            <Routes>
              {renderMultiRoutes({
                paths: [
                  "clean_bee",
                  `/${service_link}`,
                  `/${service_link}/cleaning-products`,
                  `/${service_link}/:serviceName`
                ],
                element: <Footer />
              })}
            </Routes>
          </Suspense>
          {/* <FacebookChat /> */}
          <Chatbase />
        </div>
      </>
    </AppProvider>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras,
  locale: state.settingsReducer.locale
});

const mapDispatchToProps = (dispatch: any) => ({
  setSystemSettings: (settings: settings) => {
    dispatch(setSystemSettings(settings));
  },
  changeLocale: (locale: locale) => {
    dispatch(changeLocale(locale));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

export const renderMultiRoutes = ({
  element: Element,
  paths
}: {
  element: ReactElement;
  paths: string[];
}) => paths.map((path) => <Route key={path} path={path} element={Element} />);

export const RenderExcludedRoutes = ({
  element: Element,
  excludePaths
}: {
  element: ReactElement;
  excludePaths: string[];
}) => {
  const location = useLocation();

  // Check if the current path is excluded
  const isExcluded = excludePaths.some((excludedPath) =>
    matchPath(excludedPath, location.pathname)
  );

  return isExcluded ? null : (
    <Routes>
      <Route path="*" element={Element} />
    </Routes>
  );
};

export const Raw = ({ children }: { children: string }) => {
  return <span dangerouslySetInnerHTML={{ __html: children }} />;
};
